module.exports = __webpack_public_path__ + "img/ellipse.8049eea8.svg";